import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CommonService } from '../service/common.service';
import { AdminshareService } from "../service/adminshare.service";
import { MonshinService } from "../service/monshin.service";
import { ShareService } from '../service/share.service';
import { UsersService } from '../service/users.service';
import { removeDebugNodeFromIndex } from '@angular/core/src/debug/debug_node';

import { AnswerStatus, Mode, QuestionType } from '../app.constant';

declare var $;

@Component({
  selector: 'app-a0112-answer-main-preview',
  templateUrl: './a0112-answer-main-preview.component.html',
  styleUrls: ['./a0112-answer-main-preview.component.css']
})
export class A0112AnswerMainPreviewComponent implements OnInit {
  categoryInfo: any = null;
  questionList: any[] = null;
  questionListBk: any[] = null;
  startResultList: any[] = null;
  inspectionList :any[];
  mode: number;
  answer_result_list: any[] = null;
  errorList: any[] = null;

  ANSWER_STATUS: any = AnswerStatus;
  MODE: any = Mode;
  Q_TYPE: any = QuestionType;

  kaitouVal: string;
  checkId: number;
  userInfo: any;
  answerUserInfo: any;
  settingMonsinInfo: any;

  //componet間共有のため
  constructor(
    private commonService: CommonService,
    private usersService: UsersService,
    private monshinService: MonshinService,
    private adminShareService: AdminshareService,
    private router: Router,
    private shareService: ShareService,
    private location: Location,
  ) { }

  ngOnInit() {
    //component読み込みのため、スクロール位置を固定で一番上に
    window.scrollTo(0, 0);

    this.userInfo = this.usersService.userinfo;
    this.answerUserInfo = this.shareService.getAnswerUserInfo();
    this.settingMonsinInfo = this.shareService.getSettingMonsinInfo();
    this.categoryInfo = this.shareService.getCategoryInfoShare();
    this.questionList = this.shareService.getQuestionListShare();
    this.startResultList = this.shareService.getStartResultListShare();
    this.inspectionList =this.shareService.getInspectionListShare();
    this.mode = this.shareService.getModeShare();

    if (this.categoryInfo == null) {
      this.commonService.modalOpens(90002, modalresult => {
        this.router.navigate(["/admin"]);
      });
    } else {
      //Shareから取得できなかった時にDBから取得する
      if (this.questionList == null) this.getQuestionList(this.categoryInfo);

    }
  }

  getQuestionList(categoryInfo): void {
    let params = {
      "t_person_id": this.categoryInfo["t_person_id"],
      "t_event_id": this.categoryInfo["t_event_id"],
      "t_question_category_id": this.categoryInfo["t_question_category_id"],
      "m_question_category_id": this.categoryInfo["m_question_category_id"],
      "m_language_id": this.categoryInfo["m_language_id"],
    };
    this.monshinService.getQuestionList(params)
      .subscribe((res: Response) => {

        if (res["fuel_status"] == "OK") {
          //questionListが0レコードならエラー
          this.questionList = res["fuel_results"]["question_list"];
          //PREモードのリセットボタン用にデータを"値渡し"で保持
          this.shareService.setQuestionListShare(JSON.parse(JSON.stringify(this.questionList)));
        }else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
        }else{
          this.commonService.modalOpens(11003,modalresult=>{});
        }
      }, error => {
        this.commonService.modalOpens(error, modalresult => { });
      });
  }

  /**
   * チェックを行い
   * 問題なければ確認画面に遷移する
   * @param temp 
   */
  onSubmit(temp) {
    //バリデーションチェックなど
    //shareにあるエラーリストを初期化
    this.shareService.refleshErrorListShare();

    //表示Flagの付与
    let resultList = [];
    //1次階層は基本質問に縛られる可能性があるため、show=nullで渡す。
    resultList = this.monshinService.createResultData(resultList, this.questionList, null);

    //バリデーションチェック後のエラーリストが１レコードでもあれば、処理中断
    this.errorList = this.shareService.getErrorListShare();
    if (this.errorList != null) {
      //TOPに戻る
      window.scrollTo(0, 0);
      return;
    }

    this.shareService.setResultListShare(resultList);
    this.shareService.setQuestionListShare(this.questionList);
    //メインの質問画面に遷移
    this.router.navigate(["/answer-preview/confirm"]);

  }

  /**
   * プレビュー用チェックメソッド
   */
  check() {
    //バリデーションチェックなど
    //shareにあるエラーリストを初期化
    this.shareService.refleshErrorListShare();

    //表示Flagの付与
    let resultList = [];
    //1次階層は基本質問に縛られる可能性があるため、show=nullで渡す。
    resultList = this.monshinService.createResultData(resultList, this.questionList, null);

    //バリデーションチェック後のエラーリストが１レコードでもあれば、処理中断
    this.errorList = this.shareService.getErrorListShare();
    if (this.errorList != null) {
      //TOPに戻る
      window.scrollTo(0, 0);
      return;
    }

    this.shareService.setResultListShare(resultList);
    //this.shareService.setQuestionListShare(this.questionList);

    //チェックが無事終了したことを通知する
    this.commonService.modalOpens(12002, modalresult => { return });
  }

  reset() {
    //Modalで確認？
    // !!!! 正しいIDじゃない !!!!
    this.commonService.modalOpens(50005, modalresult => {
      if (modalresult == "OK") {
        //エラーリストのリフレッシュ
        this.shareService.refleshErrorListShare();
        this.errorList = null;

        //管理画面から渡された情報の再取得
        this.categoryInfo = this.shareService.getCategoryInfoShare();
        this.startResultList = this.shareService.getStartResultListShare();

        if (this.startResultList.length > 0) {
          this.shareService.setStartQuestionListShare(JSON.parse(JSON.stringify(this.shareService.getInitialStartQuestionListShare())));
          this.shareService.refleshStartResultListShare();

          this.router.navigate(["/answer-preview/start"]);
        } else {
          //基本情報がない場合、この画面から再読み込みを行う
          this.questionList = null;
          this.getQuestionList(this.categoryInfo);
        }

      }
    });

  }

  goRegister(question: any): void {
    this.router.navigate(["/question-register/" + this.categoryInfo["m_question_category_id"] + "/" + question["m_question_id"] + "/" + this.categoryInfo["m_language_id"] + "/" + question["result_option"]]);
  }

  goBack(): void {
    //this.location.back();
    if (this.startResultList.length > 0) {
      this.router.navigate(["/answer-preview/start"]);
    } else {
      if (this.mode == this.MODE.PRE) {
        this.router.navigate(["/question-list/" + this.categoryInfo["m_question_category_id"] + "/" + this.categoryInfo["m_language_id"]]);
      }else if (this.mode == this.MODE.END) {
        this.router.navigate(["/question-category/" + this.adminShareService.set_question_category.event_id]);
      } else {
        this.router.navigate(["/person/" + this.categoryInfo["t_event_id"]]);
      }
    }



  }

  selectP(p: string): void {
    $('html,body').animate(
      { scrollTop: $(`#qid${p}`).offset().top }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/a0112-answer-preview/a0112-answer-main-preview.component.ts